define('core/utils/html',[],function () {
    'use strict';

    var ELLIPSIS_TEXT = '...';
    var ELLIPSIS_TEXT_LENGTH = ELLIPSIS_TEXT.length;

    var parseHTML = function (html) {
        var parsed;

        try {
            parsed = new window.DOMParser().parseFromString('<!doctype html><meta charset=utf-8><title> </title>', 'text/html');
        } catch (err) {
            // Pass
        }

        // Fallback to alternative, insecure implementation
        // This is only to support PhantomJS and very old mobile browsers
        if (!parsed)
            parsed = window.document.implementation.createHTMLDocument('');

        parsed.body.innerHTML = html;

        return parsed;
    };

    return {
        /**
         * Remove HTML tags from a string. Similar to $.text()
         *
         * It also makes the browser parse HTML entities as a side effect so
         * this is not "just strip tags", BEWARE!
         *
         * @param {string} html A string possibly containing html tags like <p></p>
         * @returns {string} plain text (all html tags removed)
         */
        stripTags: function (html) {
            var doc = parseHTML(html).body;
            return (doc.textContent || doc.innerText).replace(/\r?\n/g, ' ');
        },

        /**
         * Replace anchor tags in given HTML with result from `replaceFn`.
         * Any of the anchor's inner html is preserved except for the
         * anchor's href, if present.
         *
         * `replaceFn` is called with the link object it is replacing.
         *
         * @param {string} inputHTML A raw HTML string containing <a> tags
         * @param {function(number)} replaceFn The function that returns the replacement of the anchor tag
         * @returns {string} An HTML string with replaced anchor tags
         */
        replaceAnchors: function (inputHTML, replaceFn) {
            var parsed = parseHTML(inputHTML);

            [].forEach.call(parsed.querySelectorAll('a'), function (anchor) {
                var href = anchor.getAttribute('href') || '';
                var html = anchor.innerHTML;

                var replaceValue = replaceFn(anchor);

                // Check if innerHTML is just the truncated version of HREF
                // value. `.slice()` is to remove the `...` truncation at the end.
                if (href.indexOf(html.slice(0, -ELLIPSIS_TEXT_LENGTH)) === 0)
                    html = replaceValue;

                // Else, if the innerHTML just _contains_ the HREF, then we
                // replace the whole HREF there.
                else if (href.length && html.indexOf(href) !== -1)
                    html = html.replace(href, replaceValue);
                // Otherwise, we append the `replaceValue`
                else
                    html += ' ' + replaceValue;

                // Finally, replace the entire anchor tag with the reformatted
                // inner html.
                anchor.insertAdjacentHTML('afterend', html);
                anchor.parentNode.removeChild(anchor);
            });

            return parsed.body.innerHTML.trim();
        },
    };
});

